import { render, staticRenderFns } from "./RatingItem.vue?vue&type=template&id=070e31bd&scoped=true&"
import script from "./RatingItem.vue?vue&type=script&lang=js&"
export * from "./RatingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e31bd",
  null
  
)

export default component.exports